import { StyleSheet, Text, View } from "react-native";
import React from "react";
import Layout from "~components/atoms/Layout/index.web";

const SalesFeed = () => {
  return (
    <Layout>
      <Text>SalesFeed</Text>
    </Layout>
  );
};

export default SalesFeed;

const styles = StyleSheet.create({});
